import { GoogleSigninButtonModule } from "@abacritt/angularx-social-login";
import { NgFor, NgIf } from "@angular/common";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnInit, signal, ViewChild, WritableSignal } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { DeviceDetectorService } from "ngx-device-detector";
import { first, firstValueFrom } from "rxjs";
import { ConfigService } from "src/app/servicios/config/config.service";
import { GfkService } from "src/app/servicios/gfk/gfk.service";
import { PlatformService } from "src/app/servicios/platform/platform.service";
import { KebabCasePipe } from "../../pipes/kebab-case.pipe";
import { PublicidadService } from "../../servicios/publicidad/publicidad.service";
import { EstructuraDefectoComponent } from "./estructura-defecto/estructura-defecto.component";
import { EstructuraSeccionComponent } from "./estructura-seccion/estructura-seccion.component";
import { ReelsService } from "@src/app/servicios/reels.service";
import { Orientation } from "@src/app/models/enums/orientation.enum";
import { PortadaService } from "@src/app/servicios/portada/portada.service";
import { Noticia } from "@src/app/models/interfaces/noticia.interface";
import { CanonicalService } from "@src/app/servicios/canonical/canonical.service";
import { MetaDefinition } from "@angular/platform-browser";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
  imports: [RouterLink, EstructuraDefectoComponent, EstructuraSeccionComponent, KebabCasePipe, GoogleSigninButtonModule, NgIf, NgFor],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent implements OnInit {
  @Input() showFecha: boolean;
  isMobile: boolean = false;
  mensajeError = "";
  canales = [];
  videosDirecto: Noticia[] = [];
  publicidad_bloques = {};
  publicidad_divisores_movil = [];
  publicidadCabecera: any;
  publicidadTop: any;
  publicidadOver: any;
  numPubli = 0;
  constantesGlobales: WritableSignal<any>;
  posVideo = 0;
  heightVideo = 0;

  selectorName: any;
  configBloque: any;
  showBloque: any;
  estructuraBySeccion = false;

  @ViewChild("mostrarContenedor") mostrarContenedorIframes: ElementRef<HTMLDivElement>;
  showIframesComponent = false;

  constructor(
    public readonly router: Router,
    private readonly portadaService: PortadaService,
    private readonly deviceService: DeviceDetectorService,
    private readonly publiService: PublicidadService,
    private readonly elementRef: ElementRef,
    private readonly configService: ConfigService,
    private readonly platformService: PlatformService,
    private readonly gfkService: GfkService,
    private readonly cd: ChangeDetectorRef,
    private readonly reelsService: ReelsService,
    private readonly canonicalService: CanonicalService,
  ) {
    this.reelsService.setOrientation(Orientation.Clasico);
  }

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobile();
    this.constantesGlobales = signal(this.configService.getConstantesGlobales());
    this.updateMetaTags();
    if (this.constantesGlobales().gfk === true && this.platformService.isBrowser()) {
      this.initGfk();
    }

    this.selectorName = this.elementRef.nativeElement.tagName.toLowerCase();
    const configPrensa = this.configService.getConfigPrensa();
    if (configPrensa) {
      configPrensa.pipe(first()).subscribe((resultConfig) => {
        if (resultConfig) {
          this.configBloque = resultConfig.general[this.selectorName];
          if (this.configBloque.config_orden_portada_seccion === "true") {
            this.estructuraBySeccion = true;
          }
        }
      });
    }
    if (this.configBloque.has_live_video === "true") {
      firstValueFrom(this.portadaService.getVideosDirecto(1, this.constantesGlobales().idCanalDirecto)).then((result: Noticia[]) => {
        this.videosDirecto = result;
        this.cd.detectChanges();
      });
    }
    this.getPublicidad();
  }
  getPublicidad(): void {
    const publi = this.publiService.getPubli();
    if (publi) {
      publi.pipe(first()).subscribe((result) => {
        if (result != null) {
          let numPubli = 0;
          const arrayPublicidadCabecera = result.imagenes.filter((item) => item.idPosicion === "1");
          numPubli = Math.floor(Math.random() * arrayPublicidadCabecera.length);
          this.publicidadCabecera = arrayPublicidadCabecera[numPubli];

          const arrayPublicidadTop = result.imagenes.filter((item) => item.idPosicion === "49");
          numPubli = Math.floor(Math.random() * arrayPublicidadTop.length);
          this.publicidadTop = arrayPublicidadTop[numPubli];

          const arrayPublicidadOver = result.imagenes.filter((item) => item.idPosicion === "51");
          numPubli = Math.floor(Math.random() * arrayPublicidadOver.length);
          this.publicidadOver = arrayPublicidadOver[numPubli];

          result.imagenes.forEach((currentValue) => {
            if ((currentValue.idPosicion === "27" || currentValue.idPosicion === "28" || currentValue.idPosicion === "29") && (currentValue.id_tipo === "40" || currentValue.id_tipo === "41" || currentValue.id_tipo === "42" || currentValue.id_tipo === "43" || currentValue.id_tipo === "44")) {
              this.publicidad_bloques[currentValue.nombrePosicion.replace("Divisor ", "")] = currentValue;
            }
            if (currentValue.idPosicion === "34" || currentValue.idPosicion === "35" || currentValue.idPosicion === "36" || currentValue.idPosicion === "37" || currentValue.idPosicion === "38" || currentValue.idPosicion === "39" || currentValue.idPosicion === "40" || currentValue.idPosicion === "41" || currentValue.idPosicion === "42" || currentValue.idPosicion === "43" || currentValue.idPosicion === "44" || currentValue.idPosicion === "45" || currentValue.idPosicion === "46" || currentValue.idPosicion === "47" || currentValue.idPosicion === "48") {
              this.publicidad_divisores_movil[currentValue.nombrePosicion.replace("Movil - divisor fila ", "")] = currentValue;
            }
          });
        }
        this.cd.markForCheck();
      });
    }
  }

  /**
   * Actualiza las metaetiquetas de la página con información relevante
   * obtenida de las constantes globales. Estas metaetiquetas incluyen
   * descripciones, títulos, información de Open Graph, y datos de Dublin Core.
   *
   * @private
   */
  private updateMetaTags(): void {
    const metaTagsArray: MetaDefinition[] = [
      { name: "description", content: this.constantesGlobales().metaTag },
      { property: "og:title", content: this.constantesGlobales().siteTitle },
      { property: "og:type", content: "website" },
      { property: "og:image", content: `${this.constantesGlobales().siteDomain}/assets/images/${this.constantesGlobales().imgShare}` },
      { property: "og:url", content: this.constantesGlobales().siteDomain },
      { property: "og:description", content: this.constantesGlobales().metaTag },
      { property: "article:author", content: this.constantesGlobales().siteName },
      { property: "article:publisher", content: this.constantesGlobales().siteName },
      { property: "og:site_name", content: this.constantesGlobales().siteDomain },
      { name: "DC.title", content: this.constantesGlobales().siteTitle },
      { name: "DC.creator", content: this.constantesGlobales().siteTitle },
      { name: "DC.publisher", content: this.constantesGlobales().siteTitle },
      { name: "DC.description", content: this.constantesGlobales().metaTag },
      { name: "DC.subject", content: this.constantesGlobales().metaTag },
      { name: "DC.date", content: new Date() },
    ];

    this.canonicalService.updateCanonicalUrls(metaTagsArray);
  }

  private initGfk(): void {
    if (this.constantesGlobales().gfk) {
      const customParams = { c1: this.stripProtocolAndSubdomain(this.constantesGlobales().siteDomain), c2: "homepage" };
      this.gfkService.impression(customParams);
    }
  }

  stripProtocolAndSubdomain(url: string): string {
    const strippedUrl = url.replace(/^(https?:\/\/)?(www\.)?/, "");
    return strippedUrl;
  }

  trackItem(index: number, item: any): string {
    return item.id;
  }
}
